import * as React from 'react';
import { ApprovalType } from '../../../enums/ApprovalType';
import { formatDate, parseDate } from '../../../utils';
import { ApprovalCheck, CoAuthor, Person, RejectX } from '../../Icon/icon';
import TooltipPopover from '../../Popover/popover';
import './approvalsMenu.scss';

const displayName = {
  kiLeader: 'Approver',
  cor: 'COR',
  teamManager: 'Team Manager',
  emtLead: 'EMT Lead',
  delegate: 'Approver(s)'
};

const description = {
  approved: 'Approved: ',
  declined: 'Declined: '
};

export const ApprovalsMenu = ({ approvals }) => {
  const getApprovalDateLocal = approvalDateTime => {
    try {
      const parseApprovalDateTime = parseDate(approvalDateTime);
      return formatDate(parseApprovalDateTime);
    } catch (e) {
      console.error('Failed to parse date with exception', e);
      return '--';
    }
  };

  const renderAssigneeEmails = assignees => {
    if (!assignees || assignees.length === 0)
      return 'This role has not been assigned.';
    return assignees.map((assignee, idx) => (
      <div key={idx}>
        <a href={`mailto:${assignee?.props?.empEmail}`}>
          {assignee?.props?.empEmail}
        </a>
      </div>
    ));
  };

  return (
    <div>
      <div className="approval-dd-title">Required Approvals</div>
      <div className="approvals-menu">
        {approvals.map((approval, index) => {
          const assignees = approval?.taskAssignee;
          const empEmail = approval?.taskAssignee?.[0]?.props?.empEmail;
          return (
            <div className="approval" key={index}>
              <div className="approval-container">
                <div
                  className={
                    !approval?.approvalStatus ? 'node pending' : 'node'
                  }
                >
                  {approval?.approvalStatus == ApprovalType.Approved ? (
                    <ApprovalCheck />
                  ) : approval?.approvalStatus == ApprovalType.Declined ? (
                    <RejectX />
                  ) : null}
                </div>

                {index < approvals.length - 1 && <div className="line"></div>}
              </div>
              <div className="text-container">
                <div className="role">
                  {displayName[approval?.role]}
                  <TooltipPopover
                    pointerPosition="top"
                    content={<div>{renderAssigneeEmails(assignees)}</div>}
                    type="info"
                    packed={true}
                    children={assignees?.length > 1 ? <CoAuthor /> : <Person />}
                  />
                </div>
                <div className="description">
                  {`${
                    approval?.approvalStatus
                      ? description[approval?.approvalStatus] +
                        getApprovalDateLocal(approval?.approvalDateTime)
                      : 'Pending'
                  }`}
                </div>
              </div>
            </div>
          );
        })}
      </div>
    </div>
  );
};
